var siteServiceObj = {
    getProoOffers() {
        return axios.get("/api/Site/Offers");
    },

    getOrdersCount() {
        return axios.get("/api/Site/OrdersCount");
    },

    postMessage(message) {
        return axios.post("api/Site/SendMessage", message);
    },

    getPaymentUrl(data) {
        return axios.post("api/Site/GetPaymentUrl", data);
    },
    setAccountToOrder(data) {
        return axios.post("api/Site/SetAccountToOrder", data);
    },
    issuePolicy(data) {
        //
        return axios.post("/api/Site/IssuePolicy", data, { errorHandle: true });
    },

    getMyOrders() {
        //
        return axios.get("/api/Site/MyOrders");
    }
};
export const siteService = siteServiceObj;
